import { jsx as _jsx } from "react/jsx-runtime";
export var AvatarStack = function (_a) {
    var items = _a.items;
    return (_jsx("div", { style: { display: "flex", alignItems: "center" }, children: items.map(function (item, idx) { return (_jsx("span", { title: item.title, style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 22,
                height: 22,
                borderRadius: 999,
                border: "1px solid var(--pal-border-primary)",
                background: "var(--pal-background-primary)",
                overflow: "hidden",
                marginLeft: idx === 0 ? 0 : -7,
                boxShadow: "0 0 0 2px var(--pal-background-secondary)",
            }, children: item.icon }, item.key)); }) }));
};
